/**
 * @file Map-marker-open-tab.tsx
 * @module MapMarkerOpenTab
 * @description Saites komponente, kas atver Karšu pārlūku jaunā pārlūka cilnē
 *              rediģēšanas režīmā. Izmanto SIPR sistēmas priekšpuses serviss
 *              notikumu un statisko objektu atrašanās vietu labošanai.
 */
export const MapMarkerOpenTab = () => {
  return (
    <a
      href={window.location.origin + "?edit=10"}
      target="_blank"
      rel="noreferrer"
      className="text-[#1677FF] text-sm underline"
    >
      Atvērt karti jaunā cilnē
    </a>
  );
};
